import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Grid,
    Alert,
} from '@mui/material';
import { Organization } from 'models/organization';

type ClinicSelectDialogProps = {
    handleClose: () => void;
    open: boolean;
    clinics: Organization[] | [];
    handleConfirm: (clinicId: string) => void;
};

const ClinicSelectDialog: FC<ClinicSelectDialogProps> = ({
    handleClose,
    open,
    clinics,
    handleConfirm,
}: ClinicSelectDialogProps) => {
    const { t: translate } = useTranslation(['common', 'users']);
    const [clinicId, setClinicId] = useState(clinics[0]?._id || '');

    const onClinicChange = (event: SelectChangeEvent) => {
        setClinicId(event.target.value);
    };

    const close = () => {
        setClinicId('');
        handleClose();
    };

    return (
        <div>
            <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
                <DialogTitle id="alert-dialog-title">{translate('users:SELECT_CLINIC')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item md={12} sm={12}>
                            <FormControl margin="dense" fullWidth>
                                <InputLabel required>{translate('common:CLINIC')}</InputLabel>
                                <Select
                                    value={clinicId || ''}
                                    label={translate('common:CLINIC')}
                                    onChange={onClinicChange}
                                >
                                    {clinics?.map((clinic) => {
                                        return (
                                            <MenuItem key={clinic?._id} value={clinic?._id}>
                                                {clinic?.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item md={12} sm={12}>
                            <Alert severity="info">{translate('common:CLINIC_SELECT_DIALOG_INFO')}</Alert>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={close}>{translate('common:CANCEL')}</Button>
                    <Button disabled={!clinicId} onClick={() => handleConfirm(clinicId)} variant="contained" autoFocus>
                        {translate('common:CONFIRM')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ClinicSelectDialog;
